import { Typography } from 'antd';
// import {FieldProperties} from '../../../../engine/types';
import { InputFieldProps } from '../Fields';

const { Text, Paragraph } = Typography;

const truncateString = (val: string, maxLength: number) =>
	val.length > maxLength ? val.substring(0, maxLength) + '...' : val;

export const TextField = ({ fieldValue }: InputFieldProps) => {
	if (!fieldValue) {
		return null;
	}
	if (typeof fieldValue == 'number') {
		const formattedNumber = fieldValue.toLocaleString();
		return <Text ellipsis={{ tooltip: `${fieldValue}` }}>{formattedNumber}</Text>;
	}
	const renderedText = truncateString(fieldValue, 100);
	return (
		<Paragraph ellipsis={{ rows: 1, tooltip: renderedText }} style={{ marginBottom: 0 }}>
			{renderedText}
		</Paragraph>
	);
};
